import { I18nComponente } from "@/types/gerais"

export const OTabelaAtributosi18n: I18nComponente = {
  "pt-BR": {
    nome: "nome",
    natureza: "natureza",
    pesquisarPorNatureza: "pesquisar por natureza",
    pesquisarPorNome: "pesquisar por nome",
    valoresPossiveis: "valores possíveis",
    arquivar: "arquivar",
    excluir: "excluir",
  },
  "es-CO": {
    nome: "nombre",
    natureza: "clasificación",
    pesquisarPorNatureza: "buscar por clasificación",
    pesquisarPorNome: "buscar por nombre",
    valoresPossiveis: "valores posibles",
    arquivar: "archivar",
    excluir: "excluir",
  },
}
